import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface SettingDescriptionProps {
  description: string;
}

export const SettingDescription = memo(function SettingDescription({
  description,
}: SettingDescriptionProps) {
  return <p className={cn(textVariants.footnote, "h-10 mb-2 opacity-70")}>{description}</p>;
});
